import React from 'react';
import styled from 'styled-components';

import { InputField } from '../../../../healtheraComponents';
import Switch from '../../../Shared/Switch';
import { StyledPaperContainer, StyledSectionTitle, StyledFormContainer } from '../../PlusWebsiteEditor.styles';
import { formatUrl } from '../../utils/format';
import { fullUrlRegexp } from '../../constants';

import type { WebsiteConfiguration } from '../../types/websiteConfiguration';
import type { BlurHandler, DeepFieldErrorGetter } from '../../types/handlers';

type Props = Pick<WebsiteConfiguration, 'pharmacy_required' | 'pharmacy_required_redirect'> & {
  onFieldChange: (fieldName: string, value: string | boolean) => void;
  getError: DeepFieldErrorGetter;
  onBlur: BlurHandler;
};

export default function PharmacyRequiredSection({
  onBlur,
  onFieldChange,
  getError,
  pharmacy_required,
  pharmacy_required_redirect,
}: Props) {
  const handleBlur: BlurHandler = async (e) => {
    await onBlur(e);

    if (e.target?.value.match(fullUrlRegexp)) {
      onFieldChange(e.target.name, formatUrl(e.target.value));
    }
  };

  return (
    <StyledPaperContainer>
      <StyledSectionTitle>Pharmacy Website Lite</StyledSectionTitle>
        <ColumnWithGap>
          <Switch
            withPadding={false}
            onChange={(e) => onFieldChange('pharmacy_required', e.target.checked)}
            label="Pharmacy required"
            value={!!pharmacy_required}
            checked={!!pharmacy_required}
            reverseOrder={false}
            disabled={false}
          />
          <InputField
            name="pharmacy_required_redirect"
            onBlur={handleBlur}
            onChange={(e) => onFieldChange(e.target.name, e.target.value)}
            label="Pharmacy required redirect url"
            value={pharmacy_required_redirect || null}
            helperText={getError('pharmacy_required_redirect')}
          />
      </ColumnWithGap>
    </StyledPaperContainer>
  )
}

const ColumnWithGap = styled(StyledFormContainer)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
